<template>
  <div>
    <div class="row">
      <div class="col-12">
        <div style="padding-bottom: 10px">
          <el-button size="small" type="primary" @click="newMotorAccident"><i class="fa-solid fa-car"></i>
            {{$t('Yeni_müraciət_AVTO')}}
          </el-button>
          <el-button size="small" type="primary" @click="newOtherAccident"><i class="fa-solid fa-people-roof"></i>
            {{$t('Yeni_müraciət_DİGƏR')}}</el-button>
        </div>
      </div>
    </div>
    <div class="row" style="padding-bottom: 10px">
      <div class="col-md-2">
        <label for="starDate">{{$t('Tarixdən')}}</label>
        <el-date-picker size="small" id="starDate" format="dd.MM.yyyy" type="date" :clearable="false"
          v-model="item.startDate">
        </el-date-picker>
      </div>
      <div class="col-md-2">
        <label for="endDate">{{$t('Tarixədək')}}</label>
        <el-date-picker size="small" id="endDate" format="dd.MM.yyyy" type="date" :clearable="false"
          v-model="item.endDate">
        </el-date-picker>
      </div>
      <div class="col-md-8" style="padding-bottom: 10px">
        <label>{{$t('Axtarış_növü')}}</label>
        <div class="d-flex justify-content-start">
          <div class="d-flex flex-row">
            <el-select style="width: 90%" size="small" v-model="item.searchType">
              <el-option :label="$t('--_Bütün_--')" :value="0"></el-option>
              <el-option :label="$t('Hadisə_nömrəsi')" :value="1"></el-option>
              <el-option :label="$t('SŞ_nömrəsi')" :value="2"></el-option>
              <el-option :label="$t('DQN')" :value="3"></el-option>
              <el-option :label="$t('Məsul_şəxs')" :value="4"></el-option>
              <el-option :label="$t('İştirakçılara_görə')" :value="5"></el-option>
            </el-select>
            &nbsp;
            <el-input size="small" :placeholder="$t('Axtar')" :disabled="item.searchType == 0"
              v-model="item.searchText">
              <template slot="prepend"> </template>
            </el-input>
            &nbsp;
            <el-button size="small" :title="$t('Axtarış')" type="primary" icon="el-icon-search"
              @click="getData"></el-button>
          </div>
        </div>
      </div>
      <div class="col-md-8 col-12">
        <el-checkbox @change="getData" v-model="item.rejected">{{$t('Geri_qaytarılan_işlər')}} </el-checkbox>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <el-table v-loading="loading" :data="
          data.filter(
            (data) =>
              !search ||
              data.participants.toString().includes(search) ||
              data.regionName.toLowerCase().includes(search.toLowerCase()) 
          )
        " style="width: 100%">

          <el-table-column :label="$t('Hadisə_#')" sortable prop="dispAccidentNumber" width="120">
            <template #default="scope">
              <span style="font-weight: bold">{{ scope.row.dispAccidentNumber }}</span>
            </template>
          </el-table-column>
          <el-table-column :label="$t('Tarix')" sortable prop="accidentDateStr" width="150">
          </el-table-column>
          <el-table-column :label="$t('Rayon')" prop="regionName" width="200">
          </el-table-column>
          <el-table-column :label="$t('DQN')" prop="regNumber" width="150">
          </el-table-column>
          <el-table-column :label="$t('TM-nə_göndərilib')" width="150">
            <template slot-scope="scope">
              <status-label :type="scope.row.repairCenterStatus === 1 ? 'green' : 'red'" />
              {{ scope.row.repairCenterStatus === 1 ? 'Bəli' : "Xeyr" }}
            </template>
          </el-table-column>
          <el-table-column :label="$t('F4')" width="100">
            <template slot-scope="scope">
              <status-label :type="scope.row.form4Status === 1 ? 'green' : 'red'" />
              {{ scope.row.form4Status === 1 ? 'Var' : "Yoxdur" }}
            </template>
          </el-table-column>
          <el-table-column :label="$t('İş_açılıb')" width="100">
            <template slot-scope="scope">
              <status-label :type="scope.row.createdClaim === 1 ? 'green' : 'red'" />
              {{ scope.row.createdClaim === 1 ? 'Bəli' : "Xeyr" }}
            </template>
          </el-table-column>
          <el-table-column :label="$t('İşlərin_sayı')" prop="claimCount">
          </el-table-column>
          <!-- <el-table-column :label="$t('Status')" >
            <template slot-scope="scope">
              <status-label :type="
               scope.row.statusTypeId === 30
                    ? 'indigo'
                    : '' || scope.row.statusTypeId === 35
                    ? 'forestGreen'
                    : '' || scope.row.statusTypeId === 40
                    ? 'goldenrod'
                    : '' || scope.row.statusTypeId === 45
                    ? 'limeGreen'
                    : '' 
              " />
              {{ scope.row.statusTypeName }}
            </template>
          </el-table-column> -->
          <el-table-column fixed="right" width="40">
            <template slot="header"> </template>
            <template slot-scope="scope">
              <el-button v-if="scope.row.form4Status === 1 " :title="$t('F4_yüklə')" @click="handleEdit(scope.row.id)"
                style="padding: 0 !important" size="large">
                <div class="square-icon"><i class="fa-solid fa-file-arrow-down"></i></div>
              </el-button>
            </template>
          </el-table-column>
          <el-table-column fixed="right" width="40">
            <template slot="header"> </template>
            <template slot-scope="scope">
              <el-button :title="$t('Hadisəyə_keçid')" @click="handleEdit(scope.row.id)" style="padding: 0 !important"
                size="large">
                <div class="square-icon"> <i class="fa-solid fa-up-right-from-square"></i></div>
              </el-button>
            </template>
          </el-table-column>
          <el-table-column fixed="right" width="40">
            <template slot="header"> </template>
            <template slot-scope="scope">
              <el-button @click="handleStatusView(scope.row.id,'accident')" style="padding: 0 !important">
                <div class="square-icon"> <i :title="$t('Ümumi_Statuslar')" class="fa-solid fa-timeline"></i></div>
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <client-service-user @refresh-table="getData" ref="user" />
    <accident-status-view ref="status" />
    <accident-motor ref="accident" @saved="saved" />
    <other-accident ref="otherAccident" @saved="saved" />
  </div>
</template>

<script>
  import { DateToString, AddMonths, AddDays } from "../../services/helper";
  import StatusLabel from "../components/StatusLabel.vue";
  import AccidentStatusView from "../components/AccidentStatusView.vue";
  import AccidentMotor from "./AccidentMotor.vue";
  import OtherAccident from "./OtherAccident.vue";
  import {
    GetClientServiceAccidents,
  } from "src/services/common";
  import ClientServiceUser from "./ClientServiceUser.vue";
  export default {
    components: {
      ClientServiceUser,
      StatusLabel,
      AccidentStatusView,
      AccidentMotor,
      OtherAccident
    },
    data() {
      return {
        loading: false,
        data: [],
        search: "",
        uid: this.$store.state.user.id,
        item: {
          startDate: null,
          endDate: null,
          searchType: 0,
          searchText: null,
          uid: null,
          rejected: false,
        },
        pickerOptions: {
          disabledDate(time) {
            return time.getTime() > Date.now();
          },
        },
      };

    },
    methods: {
      newMotorAccident() {
        this.$refs["accident"].new();
      },
      newOtherAccident() {
        this.$refs["otherAccident"].new();
      },
      saved(value) {
        this.handleComm(value.id);
        this.getData();
      },
      handleEdit(id) {
        this.$router.push({
          path: "accident/" + id,
        });
      },
      handleUser(item) {
        this.$refs["user"].edit(item);
      },
      handleStatusView(id, type) {
        this.$refs["status"].view(id, type);
      },
      getData() {
        this.loading = true;
        if (this.item.searchText == "") {
          this.item.searchText = null;
        }

       this.item.startDate = DateToString(this.item.startDate);
        this.item.endDate = DateToString(this.item.endDate);
        this.item.uid = this.uid;
        GetClientServiceAccidents(this.item).then((response) => {
          this.loading = false;
          if (response.data.data) {
            this.data = response.data.data;
          }
        });
      },
      loadTime() {
        this.item.startDate = AddDays(new Date(), -7);
        this.item.endDate = new Date();
      },
    },
    mounted() {
      this.loadTime();
      this.getData();
    },

  };
</script>

<style lang="css" scoped>
  .md-card .md-card-actions {
    border: 0;
    margin-left: 20px;
    margin-right: 20px;
  }

  .example-showcase .el-dropdown-link {
    cursor: pointer;
    color: var(--el-color-primary);
    display: flex;
    align-items: center;
  }
</style>